import styled from '@emotion/styled'
import { css } from '@emotion/react'

const assetsPath = window && window.env.assetHost

const sectionStyles = ({ theme }) => css`
  label: hero;

  position: relative;

  display: flex;
  align-items: center;

  width: 100%;
  min-height: 450px;

  background-color: ${theme.colors.background};
  background-image: url(${assetsPath}assets/images/lmcv/landing-page-2019/banner_landing_mobile.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;

  ${theme.media.giga} {
    min-height: 550px;

    background-color: ${theme.colors.background};

    background-image: url(${assetsPath}assets/images/lmcv/landing-page-2019/banner_principal.png);
    background-position: center center;
  }
`

const articleStyles = ({ theme }) => css`
  label: hero__article;

  color: ${theme.colors.white};

  text-align: center;

  ${theme.media.giga} {
    text-align: left;
  }
`

const wrapperLogoStyles = ({ theme }) => css`
  label: hero__wrapper-logo;

  display: flex;
  justify-content: center;
  margin-bottom: ${theme.spacings.byte};

  ${theme.media.giga} {
    display: block;
  }
`

const wrapperButton = ({ theme }) => css`
  label: hero__wrapper-button;

  a {
    z-index: ${theme.zIndex.backdrop};
  }
`

export const Section = styled('section')(sectionStyles)
export const Article = styled('article')(articleStyles)
export const WrapperLogo = styled('div')(wrapperLogoStyles)
export const WrapperButton = styled('div')(wrapperButton)
